import DropPanel from './DropPanel';

export default DropPanel;
